import type { Spacing } from '@iheartjane/reefer';
import { Flex, InfoIcon, Tag, Typography } from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';
import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

const options = [
  {
    label: 'Split',
    subtitle: 'Search in nav, AI in filter bar',
    value: 'split',
    defaultOption: true,
  },
  {
    label: 'Navigation',
    subtitle: 'Both in the top navigation',
    value: 'header',
  },
  {
    label: 'Filter bar',
    subtitle: 'Both in the filter bar',
    value: 'filters',
  },
  {
    label: 'Full-width',
    subtitle: 'Search spans the page, AI inside it',
    value: 'content_header',
  },
];

export const SearchSection = () => {
  const { setValue, watch } = useFormContext();
  const formValue = watch('search.position');

  const handleOptionChange = (option: string | boolean) => {
    setValue('search.position', option, { shouldDirty: true });
  };

  const radioOptions = useMemo(() => {
    return options.map(({ value, label, subtitle, defaultOption }, index) => {
      return {
        id: value.toString(),
        value,
        label,
        wrapper: (children: ReactNode) => (
          <Flex
            mb={index === options.length - 1 ? 0 : 16}
            justifyContent="space-between"
            border="grays-light"
            p={16}
            ariaLabel={label}
            onClick={() => handleOptionChange(value)}
            borderRadius="sm"
            alignItems="center"
          >
            <Flex flexDirection="column">
              {children}
              <Typography ml={36 as Spacing} variant="mini">
                {subtitle}
              </Typography>
            </Flex>
            {defaultOption && (
              <Tag label="Default" background="grays-ultralight" size="sm" />
            )}
          </Flex>
        ),
      };
    });
  }, [options]);

  return (
    <Flex flexDirection="column" mb={24}>
      <Typography variant="body-bold">Placement</Typography>
      <Typography variant="mini" color="grays-mid" mb={8}>
        Where shoppers find search and the AI Budtender
      </Typography>
      <Form.RadioFieldGroup
        typography="mini-bold"
        name="search.position"
        options={radioOptions}
      />
      {(formValue === 'filters' || formValue === 'content_header') && (
        <Flex alignContent="center" mt={12}>
          <InfoIcon size="sm" mr={12} mt={4} color="grays-mid" />
          <Typography variant="mini" width={'90%'} color="grays-mid">
            Navigation keeps a search icon so shoppers can search from anywhere
          </Typography>
        </Flex>
      )}
    </Flex>
  );
};
